import styled, { css } from "styled-components";
export const ProductCardWrap = styled.a `
	display: flex;
	flex-direction: column;
	background-color: white;
	box-sizing: border-box;
	position: relative;
	transition: all 0.3s ease;
	text-decoration: none;

	${(props) => {
    if (typeof props.width === "number" || !isNaN(+props.width)) {
        return css `
				width: ${props.width}px;
			`;
    }
    return css `
			width: ${props.width || "291px"};
		`;
}}

	&:hover {
		border-color: #eaeaea;
		-webkit-box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
		box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
		text-decoration: none;

		& > .image:after {
			background-color: rgba(255, 255, 255, 0.1);
		}
	}
	.priceViewOrange {
		color: #ff5a00;
	}
	.priceViewTomato {
		color: #e53b2f;
	}
`;
export const ProductCardPoster = styled.section `
	width: 100%;
	position: relative;
	display: block;
	background: #fff;

	${(props) => {
    if (props.posterRatio) {
        const gap = `calc(${props.posterRatio} * 100%)`;
        return css `
				padding-bottom: ${gap};
			`;
    }
    return css `
			padding-bottom: 100%;
		`;
}}

	&:after {
		content: "";
		display: block;
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		transition: all 0.3s ease;
	}

	.productImage {
		position: absolute;
		z-index: 0;
		left: 0;
		top: 0;
		display: block;
		width: 100%;
		height: 100%;
	}
`;
export const DescriptionWrap = styled.section `
	padding: 9px 9px 12px;
	display: flex;
	flex-direction: column;
	flex: 1 auto;

	html[dir="rtl"] & {
		& > p {
			direction: rtl;
		}
	}
`;
export const DescriptSuffix = styled.section `
	overflow: hidden;
	& > span {
		font-size: 12px;
		line-height: 30px;
		color: #666;

		b {
			color: #ff3b30;
		}
	}

	& > a {
		display: block;
		float: right;
		width: 104px;
		height: 30px;
		text-align: center;
		border-radius: 2px;
		font-size: 14px;
		font-weight: 500;
		line-height: 30px;
		text-decoration: none;
		color: #fff;

		&.buyNow {
			background: linear-gradient(129deg, #fe456a 0%, #e61f17 100%);
		}
		&.comingSoon {
			background: linear-gradient(134deg, #6b9ff7 0%, #1166f7 100%);
		}
	}
`;
